import { getThemeAsset } from "@utils/theme";

interface SkinnerBoxContentProps {
  zIndex: number;
}

const SkinnerBoxContent = ({ zIndex }: SkinnerBoxContentProps) => {
  const imgSkinnerBox = getThemeAsset("/skinner-box/skinner-box.png");
  const line = getThemeAsset("/skinner-box/line.png");

  return (
    <div
      className="absolute bottom-[27px] right-[1px] flex h-[58px] w-[122px] shrink-0 items-center justify-center"
      style={{ zIndex }}
    >
      <img
        src={line}
        alt="Skinner Box"
        className="absolute bottom-[24px] right-[1px]"
      />
      <img
        src={imgSkinnerBox}
        alt="Skinner Box"
        className="h-full w-full select-none object-contain"
      />
    </div>
  );
};

export default SkinnerBoxContent;
